var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_6708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5997 12.6111V47.7552H0.492188L29.5997 12.6111ZM29.5997 0C29.5997 8.03546 23.0814 14.5537 15.0459 14.5537C7.01047 14.5537 0.492188 8.03546 0.492188 0H29.5997ZM34.4001 47.7552C34.4001 39.7117 40.9103 33.2015 48.9538 33.2015C56.9973 33.2015 63.5076 39.7198 63.5076 47.7552H34.4001ZM34.4001 35.1361V0H63.5076L34.4001 35.1361Z",
    fill: "#03363D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_6708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.0154,
    height: 48,
    fill: "white",
    transform: "translate(0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon12);
export default __webpack_public_path__ + "static/media/logoicon12.349348c1908327aeefd376fa5fc9ec53.svg";
export { ForwardRef as ReactComponent };